import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ROUTES from "config/RouteNames";
import CustomerContainer from "containers/CustomerContainer";
import Sidebar from "components/Sidebar/Sidebar";
import { Col, Container, Row } from "reactstrap";
import OrderContainer from "containers/OrderContainer";
import AccessControlContainer from "containers/AccessControlContainer";
import AgentManagementContainer from "containers/AgentManagementContainer";
import StoreListingContainer from "containers/StoreListingContainer";
import GlobalProductContainer from "containers/GlobalProductContainer";
import TourAssignmentContainer from "containers/TourAssignmentContainer";
import PlanAssignmentContainer from "containers/PlanAssignmentContainer";
import BannersContainer from "containers/BannersContainer";
import ProductCityLevelContainer from "containers/ProductCityLevelContainer";
import CategoryGlobalContainer from "containers/CategoryGlobalContainer";
import CategoryCityLevelContainer from "containers/CategoryCityLevelContainer";
import TourCreationContainer from "containers/TourCreationContainer";
import RiderManagementContainer from "containers/RiderManagementContainer";
import PromosCityLevelContainer from "containers/PromosCityLevelContainer";
import ShiftDetailContainer from "containers/ShiftDetailContainer";
import CampaignContainer from "containers/CampaignContainer";
import TopupPage from "components/pages/topup/TopupPage";
// import deliveryDate from "components/pages/deliveryDate/DeliveryDatePage";
import ZonalConfigsContainer from "containers/ZonalConfigContainer";
import PlanCreationContainer from "containers/PlanCreationContainer";
import CnicVerificationContainer from "containers/CnicVerificationContainer";
import DeliveryDateContainer from "containers/DeliveryDateContainer";
import MetricsContainer from "containers/MetricsContainer";
import PaiyaContainer from "containers/PaiyaContainer";
// import WarehouseStaffContainer from "../containers/WarehouseStaffContainer";
import NewsfeedContainer from "containers/NewsfeedContainer";
import LiveopsContainer from "../containers/LiveopsContainer";
import AgentAssignmentContainer from "containers/AgentAssignmentContainer";
import PaiyaGiftsContainer from "containers/PaiyaGiftsContainer";

const DashboardRoutes = (props: any) => {
  return (
    <>
      <Container fluid>
        <Row>
          <Col xs="2">
            <Sidebar path={props.location} />
          </Col>
          <Col xs="10">
            <section className="stage-container">
              <Switch>
                <Route
                  exact
                  path={ROUTES.DASHBOARD_ORDER}
                  component={OrderContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_CNIC_VERIFICATION}
                  component={CnicVerificationContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_TOPUP}
                  component={TopupPage}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_DELIVERY_DATE}
                  component={DeliveryDateContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_CAMPAIGN}
                  component={CampaignContainer}
                />
                {/* <Route
                  exact
                  path={ROUTES.DASHBOARD_CUSTOMER}
                  component={CustomerContainer}
                /> */}
                {/* TODO: Will be cleaned on Global product Cleanup */}
                {/* <Route
                  exact
                  path={ROUTES.DASHBOARD_GLOBAL_PRODUCT}
                  component={GlobalProductContainer}
                /> */}
                <Route
                  exact
                  path={ROUTES.DASHBOARD_BANNERS}
                  component={BannersContainer}
                />
                {/* <Redirect
                  from={ROUTES.DASHBOARD_ROOT}
                  to={ROUTES.DASHBOARD_CUSTOMER}
                  exact
                /> */}
                <Route
                  exact
                  path={ROUTES.DASHBOARD_ACCESS_CONTROL}
                  component={AccessControlContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_AGENT_MANAGEMENT}
                  component={AgentManagementContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_AGENT_ASSIGNMENT}
                  component={AgentAssignmentContainer}
                />
                {/* <Route
                  exact
                  path={ROUTES.DASHBOARD_STORE_LISTING}
                  component={StoreListingContainer}
                /> */}
                <Route
                  exact
                  path={ROUTES.DASHBOARD_PROMOS_CITY_LEVEL}
                  component={PromosCityLevelContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_TOUR_ASSIGNMENT}
                  component={TourAssignmentContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_SHIFT_DETAIL}
                  component={ShiftDetailContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_PLAN_ASSIGNMENT}
                  component={PlanAssignmentContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_TOUR_CREATION}
                  component={TourCreationContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_PRODUCT_CITY_LEVEL}
                  component={ProductCityLevelContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_CATEGORY_GLOBAL}
                  component={CategoryGlobalContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_CATEGORY_CITY_LEVEL}
                  component={CategoryCityLevelContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_RIDER_MANAGEMENT}
                  component={RiderManagementContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_ZONAL_CONFIG}
                  component={ZonalConfigsContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_PLAN_CREATION}
                  component={PlanCreationContainer}
                />
                {/* <Route
                  exact
                  path={ROUTES.DASHBOARD_WAREHOUSE_STAFF}
                  component={WarehouseStaffContainer}
                /> */}
                <Route
                  exact
                  path={ROUTES.DASHBOARD_METRICS}
                  component={MetricsContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_PAIYA}
                  component={PaiyaContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_NEWSFEED}
                  component={NewsfeedContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_LIVEOPS}
                  component={LiveopsContainer}
                />
                <Route
                  exact
                  path={ROUTES.DASHBOARD_PAIYA_GIFTS}
                  component={PaiyaGiftsContainer}
                />
              </Switch>
            </section>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DashboardRoutes;
